<template lang="html">
  <vs-dropdown ref="nots_drop" vs-custom-content vs-trigger-click class="cursor-pointer ml-4">
     <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="notifications.length"></feather-icon>
     <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

       <div class="notification-top text-center p-5 bg-primary text-white">
         <h3 class="text-white">Hai {{ notifications.length }}</h3>
         <p class="opacity-75">Notifiche</p>
       </div>

       <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings">
       <ul class="bordered-items">
         <li v-for="ntf in notifications" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer"
         @click="betterOpen(ntf)">
           <div class="flex items-start">
             <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
             <div class="mx-2">
               <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
               <small>{{ ntf.msg }}</small>
               <template v-if="ntf.date">
                <br>
                <small :class="[`text-${ntf.category}`]">{{ ntf.date }}</small>
               </template>
             </div>
           </div>
           <!-- <small class="mt-1 whitespace-no-wrap">{{ $elapsedTime(ntf.time) }}</small> -->
         </li>
       </ul>
       </VuePerfectScrollbar>
                 <div class="
                     checkout-footer
                     fixed
                     bottom-0
                     rounded-b-lg
                     text-primary
                     w-full
                     p-2
                     font-semibold
                     text-center
                     border
                     border-b-0
                     border-l-0
                     border-r-0
                     border-solid
                     d-theme-border-grey-light
                     cursor-pointer">
                     <span>&nbsp;</span>
                 </div>
     </vs-dropdown-menu>
   </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
    components: {
        VuePerfectScrollbar
    },
    data () {
        return {
            notifications: [
                // {
                //     index: 0,
                //     title: 'Prova',
                //     msg: 'Are your going to meet me tonight?',
                //     icon: 'MessageSquareIcon',
                //     time: 'Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)',
                //     category: 'primary',
                // },
            ],
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },

    created() {
        this.refreshNotifications()
        this._int = setInterval(() => {
            this.refreshNotifications()
        }, 1*1000000) // 1000 secs ~ 17mins
    },

    beforeDestroy() {
        clearInterval(this._int)
    },

    methods: {
        betterOpen(not) {
          if (this.$route.name == not.route) {
          // this.$ref.nots_drop
            this.$vs.notify({
              color: 'warning',
              time: 4000,
              title: 'Impossibile',
              text: 'Sei già alla pagina '+not.pag_name
            })
          } else {
            not.open()
          }
        },
        refreshNotifications () {
            let nots = this.notifications = []
            axios.get(process.env.VUE_APP_BACKEND_API+'/preventivo/in_scadenza', {
                withCredentials: true,
            }) .then(res => {
                res.data.in_scadenza.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Preventivo in scadenza`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)} - scade`,
                        date: `${this.$tariffe.formatDateNew(x.preventivo_data_scadenza)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'warning',
                        route: 'documenti-preventivi',
                        pag_name: 'Preventivi',
                        open: () => this.$router.push({name:'documenti-preventivi',params:{wanted_id:x.preventivo_id}})
                    })
                })
                res.data.scaduti.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Preventivo scaduto`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'danger',
                        route: 'documenti-preventivi',
                        pag_name: 'Preventivi',
                        open: () => this.$router.push({name:'documenti-preventivi',params:{wanted_id:x.preventivo_id}})
                    })
                })
                res.data.aperti.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Preventivo aperto da 3 giorni`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)} - scade`,
                        date: `${this.$tariffe.formatDateNew(x.preventivo_data_scadenza)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'warning',
                        route: 'documenti-preventivi',
                        pag_name: 'Preventivi',
                        open: () => this.$router.push({name:'documenti-preventivi',params:{wanted_id:x.preventivo_id}})
                    })
                })
            })
            axios.get(process.env.VUE_APP_BACKEND_API+'/preventivo/passaggio_stati', {
                withCredentials: true,
            }) .then(res => {
                res.data.aperto.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Preventivo aperto`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)}`,
                        icon: 'MessageCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'primary',
                        route: 'documenti-preventivi',
                        pag_name: 'Preventivi',
                        open: () => this.$router.push({name:'documenti-preventivi',params:{wanted_id:x.preventivo_id}})
                    })
                })
                res.data.accettato.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Preventivo accettato`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)}`,
                        icon: 'ArrowUpCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'success',
                        route: 'documenti-preventivi',
                        pag_name: 'Preventivi',
                        open: () => this.$router.push({name:'documenti-preventivi',params:{wanted_id:x.preventivo_id}})
                    })
                })
                res.data.rifiutato.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Preventivo rifiutato`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)}`,
                        icon: 'ArrowDownCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'danger',
                        route: 'documenti-preventivi',
                        pag_name: 'Preventivi',
                        open: () => this.$router.push({name:'documenti-preventivi',params:{wanted_id:x.preventivo_id}})
                    })
                })
            })

            axios.get(process.env.VUE_APP_BACKEND_API+'/contratto/in_scadenza', {
                withCredentials: true,
            }) .then(res => {
                res.data.in_scadenza.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Contratto in scadenza`,
                        msg: `${x.azienda_ragione_sociale} - decorre`,
                        date: `${this.$tariffe.formatDateNew(x.contratto_data_decorrenza)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'warning',
                        route: 'documenti-contratti',
                        pag_name: 'Contratti',
                        open: () => this.$router.push({name:'documenti-contratti',params:{wanted_id:x.contratto_id}})
                    })
                })
                res.data.scaduti.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Contratto scaduto`,
                        msg: `${x.azienda_ragione_sociale}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'danger',
                        route: 'documenti-contratti',
                        pag_name: 'Contratti',
                        open: () => this.$router.push({name:'documenti-contratti',params:{wanted_id:x.id}})
                    })
                })
                res.data.aperti.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Contratto aperto da 3 giorni`,
                        msg: `${x.azienda_ragione_sociale} - decorre`,
                        date: `${this.$tariffe.formatDateNew(x.contratto_data_decorrenza)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'warning',
                        route: 'documenti-contratti',
                        pag_name: 'Contratti',
                        open: () => this.$router.push({name:'documenti-contratti',params:{wanted_id:x.contratto_id}})
                    })
                })
            })
            axios.get(process.env.VUE_APP_BACKEND_API+'/contratto/passaggio_stati', {
                withCredentials: true,
            }) .then(res => {
                res.data.revisionato.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Contratto revisionato`,
                        msg: `${x.azienda_ragione_sociale} - decorre`,
                        date: `${this.$tariffe.formatDateNew(x.contratto_data_decorrenza)}`,
                        icon: 'MessageCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'primary',
                        route: 'documenti-contratti',
                        pag_name: 'Contratti',
                        open: () => this.$router.push({name:'documenti-contratti',params:{wanted_id:x.contratto_id}})
                    })
                })
                res.data.accettato.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Contratto accettato`,
                        msg: `${x.azienda_ragione_sociale} - decorre`,
                        date: `${this.$tariffe.formatDateNew(x.contratto_data_decorrenza)}`,
                        icon: 'ArrowUpCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'success',
                        route: 'documenti-contratti',
                        pag_name: 'Contratti',
                        open: () => this.$router.push({name:'documenti-contratti',params:{wanted_id:x.contratto_id}})
                    })
                })
                res.data.rifiutato.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Contratto rifiutato`,
                        msg: `${x.azienda_ragione_sociale} - decorre`,
                        date: `${this.$tariffe.formatDateNew(x.contratto_data_decorrenza)}`,
                        icon: 'ArrowDownCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'danger',
                        route: 'documenti-contratti',
                        pag_name: 'Contratti',
                        open: () => this.$router.push({name:'documenti-contratti',params:{wanted_id:x.contratto_id}})
                    })
                })
            })
            axios.get(process.env.VUE_APP_BACKEND_API+'/board/passaggio_stati', {
                withCredentials: true,
            }) .then(res => {
                res.data.to_decisione.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Lead in corso di decisione`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)} - scade`,
                        date: `${this.$tariffe.formatDateNew(x.lead_data_scadenza)}`,
                        icon: 'MessageCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'primary',
                        route: 'leads-board',
                        pag_name: 'Leads Board',
                        open: () => this.$router.push({name:'leads-board',params:{wanted_id:x.lead_id}})
                    })
                })
                res.data.to_vendita.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Lead passaggio alle vendite`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)} - scade`,
                        date: `${this.$tariffe.formatDateNew(x.lead_data_scadenza)}`,
                        icon: 'MessageCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'primary',
                        route: 'leads-board',
                        pag_name: 'Leads Board',
                        open: () => this.$router.push({name:'leads-board',params:{wanted_id:x.lead_id}})
                    })
                })
                res.data.wait_vendita.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Lead in attesa di vendita`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)} - scade`,
                        date: `${this.$tariffe.formatDateNew(x.lead_data_scadenza)}`,
                        icon: 'MessageCircleIcon',
                        // time: x.preventivo_data_decorrenza,
                        category: 'primary',
                        route: 'leads-board',
                        pag_name: 'Leads Board',
                        open: () => this.$router.push({name:'leads-board',params:{wanted_id:x.lead_id}})
                    })
                })
            })
            axios.get(process.env.VUE_APP_BACKEND_API+'/board/alert_lead', {
                withCredentials: true,
            }) .then(res => {
                res.data.in_scadenza.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Lead in scadenza`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)} - scade`,
                        date: `${this.$tariffe.formatDateNew(x.lead_data_scadenza)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'warning',
                        route: 'leads-board',
                        pag_name: 'Leads Board',
                        open: () => this.$router.push({name:'leads-board',params:{wanted_id:x.lead_id}})
                    })
                })
                res.data.scaduti.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Lead scaduto`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'danger',
                        route: 'leads-board',
                        pag_name: 'Leads Board',
                        open: () => this.$router.push({name:'leads-board',params:{wanted_id:x.lead_id}})
                    })
                })
                res.data.stuck.map(x => {
                    nots.push({
                        index: nots.length,
                        title: `Lead fermo da 3 giorni`,
                        msg: `${x.azienda_ragione_sociale || (x.contatto_nome+' '+x.contatto_cognome)} - scade`,
                        date: `${this.$tariffe.formatDateNew(x.lead_data_scadenza)}`,
                        icon: 'AlertCircleIcon',
                        // time: x.preventivo_data_scadenza,
                        category: 'warning',
                        route: 'leads-board',
                        pag_name: 'Leads Board',
                        open: () => this.$router.push({name:'leads-board',params:{wanted_id:x.lead_id}})
                    })
                })
            })
        },
    },
}
</script>

<style lang="css" scoped>
</style>
